import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { login_path, passwords_path } from '@/rails/routes';
import { Form, Link } from '@inertiajs/react';

const TEXT_LINK =
  'rounded-sm underline decoration-accent underline-offset-4 hover:decoration-foreground focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring';

interface Props {
  emailAddress?: string;
  error?: string | null;
}

const New = ({ emailAddress, error }: Props) => {
  return (
    <>
      <h1 className="authority-display text-3xl leading-tight">Reset your password</h1>
      <p className="text-muted-foreground mt-2 text-sm leading-relaxed">
        Enter the email you log in with. We will send a link to choose a new password.
      </p>

      <Form method="post" action={passwords_path()} className="mt-6 flex flex-col gap-5">
        {({ processing, errors }) => (
          <>
            {error ? (
              <p
                role="alert"
                className="border-destructive text-destructive border-l-2 pl-3 text-sm"
              >
                {error}
              </p>
            ) : null}

            <div className="flex flex-col gap-2">
              <Label htmlFor="email_address">Email</Label>
              <Input
                id="email_address"
                type="email"
                name="emailAddress"
                autoComplete="email"
                autoFocus
                required
                defaultValue={emailAddress}
                aria-invalid={errors.emailAddress ? true : undefined}
                aria-describedby={errors.emailAddress ? 'email_address_error' : undefined}
              />
              {errors.emailAddress ? (
                <p id="email_address_error" className="text-destructive text-sm">
                  {errors.emailAddress}
                </p>
              ) : null}
            </div>

            <Button type="submit" size="lg" disabled={processing}>
              Send reset link
            </Button>
          </>
        )}
      </Form>

      <p className="mt-6 text-sm">
        <Link href={login_path()} className={TEXT_LINK}>
          Back to log in
        </Link>
      </p>
    </>
  );
};

export default New;
